// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ModalDocuments {
  background-color: var(--color_neutral_900);
  color: var(--color_neutral_0);
  padding: 32px;
}
.ModalDocuments .ModalDocuments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}
.ModalDocuments .ModalDocuments-header .ModalDocuments-header-title-row {
  display: flex;
  align-items: center;
  gap: 16px;
}
.ModalDocuments .ModalDocuments-header .ModalDocuments-header-title {
  color: var(--color_neutral_0);
}
.ModalDocuments .ModalDocuments-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-actions-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-actions-row .ModalDocuments-actions-files-count {
  font-size: 16px;
  font-weight: 700;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-actions-group {
  display: flex;
  gap: 16px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-actions-search-input {
  width: 120px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-dropzone {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-inline: -8px;
  padding: 8px;
  min-height: 200px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-dropzone-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex: 1 1;
  margin: -8px;
  height: calc(100% + 16px);
  border-radius: 8px;
  border: 2px dashed var(--color_primary_300);
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-dropzone-content p {
  font-size: 14px;
  line-height: 150%;
  text-align: center;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-dropzone-overlay-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-empty-search-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-empty-search-content p {
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  color: var(--color_neutral_300);
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-list {
  max-height: 300px;
  overflow-y: auto;
  flex: 1 1;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-list::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-list::-webkit-scrollbar-track {
  background: transparent;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-list::-webkit-scrollbar-thumb {
  background: var(--color_neutral_200);
  height: 80px;
  border-radius: 50px;
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-list:hover::-webkit-scrollbar-thumb {
  background: var(--color_neutral_400);
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-list::-webkit-scrollbar-thumb:active {
  background: var(--color_neutral_500);
}
.ModalDocuments .ModalDocuments-content .ModalDocuments-statistics-row {
  display: grid;
  grid-template-columns: 1fr auto;
}
.ModalDocuments .UploadListItem-skeleton-container {
  flex: 1 1;
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/modules/documents/modal-documents/modal-documents.styles.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,0CAAA;EACA,6BAAA;EACA,aAAA;AAeF;AAbE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAeJ;AAbI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAeN;AAZI;EACE,6BAAA;AAcN;AAVE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAYJ;AAVI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAYN;AAVM;EACE,eAAA;EACA,gBAAA;AAYR;AATI;EACE,aAAA;EACA,SAAA;AAWN;AATI;EACE,YAAA;AAWN;AARI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAUN;AAPI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;EAEA,YAAA;EACA,yBAAA;EAEA,kBAAA;EACA,2CAAA;AAON;AALM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AAOR;AAHI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAKN;AAFI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;AAIN;AAFM;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;AAIR;AAAI;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;AAEN;AD3FE;EACE,UAAA;EACA,WAAA;AC6FJ;AD1FE;EACE,uBAAA;AC4FJ;ADzFE;EACE,oCAdM;EAeN,YAAA;EACA,mBAAA;AC2FJ;ADvFI;EACE,oCApBS;AC6Gf;ADrFE;EACE,oCAxBY;AC+GhB;AAhBI;EACE,aAAA;EACA,+BAAA;AAkBN;AAdE;EACE,SAAA;AAgBJ","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins';\n\n.ModalDocuments {\n  background-color: var(--color_neutral_900);\n  color: var(--color_neutral_0);\n  padding: 32px;\n\n  .ModalDocuments-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n\n    .ModalDocuments-header-title-row {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n    }\n\n    .ModalDocuments-header-title {\n      color: var(--color_neutral_0);\n    }\n  }\n\n  .ModalDocuments-content {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    .ModalDocuments-actions-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .ModalDocuments-actions-files-count {\n        font-size: 16px;\n        font-weight: 700;\n      }\n    }\n    .ModalDocuments-actions-group {\n      display: flex;\n      gap: 16px;\n    }\n    .ModalDocuments-actions-search-input {\n      width: 120px;\n    }\n\n    .ModalDocuments-dropzone {\n      display: flex;\n      flex-direction: column;\n      gap: 24px;\n      margin-inline: -8px;\n      padding: 8px;\n      min-height: 200px;\n    }\n\n    .ModalDocuments-dropzone-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 16px;\n      flex: 1;\n\n      margin: -8px;\n      height: calc(100% + 16px);\n\n      border-radius: 8px;\n      border: 2px dashed var(--color_primary_300);\n\n      p {\n        font-size: 14px;\n        line-height: 150%;\n        text-align: center;\n      }\n    }\n\n    .ModalDocuments-dropzone-overlay-content {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .ModalDocuments-empty-search-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      gap: 16px;\n      padding: 40px;\n\n      p {\n        font-size: 14px;\n        line-height: 150%;\n        text-align: center;\n        color: var(--color_neutral_300);\n      }\n    }\n\n    .ModalDocuments-list {\n      max-height: 300px;\n      overflow-y: auto;\n      flex: 1;\n      @include scrollbar();\n    }\n\n    .ModalDocuments-statistics-row {\n      display: grid;\n      grid-template-columns: 1fr auto;\n    }\n  }\n\n  .UploadListItem-skeleton-container {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
